"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/** 积分相关（独立于营销 /marketing） */
var integralRouter = {
  path: '/integral',
  component: _layout.default,
  redirect: '/integral/exchangeConfig',
  name: 'IntegralRoot',
  meta: {
    title: '积分',
    icon: 'clipboard'
  },
  children: [{
    path: '',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/integral/index'));
      });
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    redirect: 'exchangeConfig',
    children: [{
      path: 'integralconfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/integral/config/index'));
        });
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/integral/integralLog/index'));
        });
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'pointsActivity',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/pointsActivity/index'));
        });
      },
      name: 'pointsActivity',
      meta: {
        title: '积分获取配置',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'exchangeConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/exchangeConfig/index'));
        });
      },
      name: 'exchangeConfig',
      meta: {
        title: '积分兑换配置',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'userPointsManage',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/userPointsManage/index'));
        });
      },
      name: 'userPointsManage',
      meta: {
        title: '用户积分管理',
        icon: '',
        cacheDisposable: true
      }
    }, {
      path: 'systemConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/systemConfig/index'));
        });
      },
      name: 'integralSystemConfig',
      meta: {
        title: '积分系统配置',
        icon: ''
      }
    }, {
      path: 'exchangeConfig/save/:mode/:id?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/exchangeConfig/operate'));
        });
      },
      name: 'exchangeConfigOperate',
      hidden: true,
      meta: {
        title: '积分兑换配置',
        noCache: true,
        activeMenu: '/integral/exchangeConfig'
      }
    }, {
      path: 'pointsActivity/save/:mode/:id?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/pointsActivity/operate'));
        });
      },
      name: 'pointsActivityOperate',
      hidden: true,
      meta: {
        title: '积分兑换配置操作',
        noCache: true,
        activeMenu: '/integral/pointsActivity'
      }
    }, {
      path: 'exchangeConfig/goods/:activityId',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/goodsManage/index'));
        });
      },
      name: 'exchangeGoodsManage',
      hidden: true,
      meta: {
        title: '积分商品管理',
        noCache: true,
        activeMenu: '/integral/exchangeConfig'
      }
    }, {
      path: 'pointsActivity/goods/:activityId',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/goodsManage/index'));
        });
      },
      name: 'pointsGoodsManage',
      hidden: true,
      meta: {
        title: '积分商品管理',
        noCache: true,
        activeMenu: '/integral/pointsActivity'
      }
    }]
  }]
};
var _default = exports.default = integralRouter;